<template>
	<div class="library">
		<filters @update="getItems"/>
		<div class="main">
			<div class="news">
				<newsFeatured/>
			</div>

			<div class="line"/>

			<template v-if="items">
				<div class="count" v-if="items.length">{{ meta.total }} resultater</div>
				<items v-if="items.length" v-bind="{items}"/>
				<div class="empty" v-else>Ingen resultater</div>
			</template>
		</div>
	</div>
</template>

<script>
import items from "./items/index.vue";
import filters from "./filters/index.vue";
import newsFeatured from "@/components/news/featured/index.vue";

export default {
	components: {items, filters, newsFeatured},
	data() {
		return {
			loading: false,
			items: null,
			meta: {}
		}
	},
	computed: {
		query: (t) => t.$route.query,
		more: (t) => t.meta.current_page < t.meta.last_page
	},
	methods: {
		async getItems({page} = {}) {
			if (this.loading) return;
			this.loading = true;

			const {data: {data, meta}} = await this.$axios.get("client/files", {params: {
				page,
				count: 50,
				filter: {
					search: this.query.search,
					product_type: this.query.product,
					content_type: this.query.content
				}
			}});

			if (page) {
				this.items = [...this.items || [], ...data];
			} else {
				window.scrollTo(0, 0);
				this.items = data;
			}

			this.meta = meta;
			this.loading = false;
		},

		scroll() {
			const bottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 250;

			if (bottom && this.more) {
				this.getItems({page: this.meta.current_page + 1});
			}
		}
	},
	async created() {
		await this.getItems();
		this.scroll();
		window.addEventListener("scroll", this.scroll);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.scroll);
	}
};
</script>

<style lang="scss" scoped>
.library {
	position: relative;
	z-index: 0;

	.main {
		margin-left: $libFilters;
		padding: 3em;

		@include res(mobile) {
			margin-left: 0;
			padding: 15px 12px;
		}

		.news {
			@include res(mobile) {
				display: none;
			}
		}

		.line {
			background-color: #B1B1B1;
			height: 1px;
			width: 100%;
			margin: 2em 0;
			@include res(mobile) {
				display: none;
			}
		}
		.count {
			font-size: 14px;
			color: #979797;
			font-weight: 300;
			@include res(mobile) {
				margin: 10px 0;
			}
		}
		.empty {
			margin-top: 3em;
			text-align: center;
		}
	}
}
</style>
